import _typeof from "@babel/runtime/helpers/esm/typeof";
import { identifier } from './identifier';
export var defaultOptionMap = function defaultOptionMap(option) {
  if (_typeof(option) === 'object') {
    var label = option.label,
      value = option.value,
      id = option.id;
    return Object.assign({}, option, {
      label: label || value,
      value: value || label,
      id: id || identifier()
    });
  }
  return {
    id: identifier(),
    value: option,
    label: option
  };
};
export var parseOptions = function parseOptions(options, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$optionMap = _ref.optionMap,
    optionMap = _ref$optionMap === void 0 ? defaultOptionMap : _ref$optionMap,
    optionFilter = _ref.optionFilter;
  var isGrouped;
  var valueToOption = {};
  var validValues = [];
  var parseOption = function parseOption(unparsedOption, isLabel) {
    var option = unparsedOption;
    if (typeof optionMap === 'function') {
      option = optionMap(option);
    }
    if (_typeof(option) !== 'object') {
      throw new Error("Invalid option: expected an option of type \"object\", received: " + JSON.stringify(option));
    }
    if (!('id' in option)) {
      throw new Error("Invalid option: expected option to have property \"id\", received: " + JSON.stringify(option));
    }
    if (!('label' in option)) {
      throw new Error("Invalid option: expected option to have property \"label\", received: " + JSON.stringify(option));
    }
    if (!('value' in option) && !isLabel) {
      throw new Error("Invalid option: expected option to have property \"value\", received: " + JSON.stringify(option));
    }
    if (!isLabel && typeof optionFilter === 'function' && !optionFilter(option)) {
      return null;
    }
    if (!option.disabled && !isLabel) {
      validValues.push(option.value);
      valueToOption[option.value] = option;
    }
    return option;
  };
  var parsedOptions = options.reduce(function (parsed, option) {
    if (Array.isArray(option)) {
      if (isGrouped === false) {
        throw new Error("Invalid options array: expected an option of type \"object\", received an \"array\": " + JSON.stringify(option));
      }
      isGrouped = true;
      var groupOptions = option.reduce(function (parsedGroup, groupOption, i) {
        var parsedOption = parseOption(groupOption, !i);
        if (parsedOption) {
          parsedGroup.push(parsedOption);
        }
        return parsedGroup;
      }, []);
      if (groupOptions.length > 1) {
        parsed.push(groupOptions);
      }
    } else {
      if (isGrouped) {
        throw new Error("Invalid options array: expected an optgroup of type \"array\", received: " + JSON.stringify(option));
      }
      isGrouped = false;
      var parsedOption = parseOption(option);
      if (parsedOption) {
        parsed.push(parsedOption);
      }
    }
    return parsed;
  }, []);
  return {
    isGrouped: isGrouped,
    valueToOption: valueToOption,
    validValues: validValues,
    parsedOptions: parsedOptions
  };
};